import React from 'react';
import { Col, Row } from 'react-bootstrap';
import LeftSide from '../main/left-side';
import Navbar from '../navigation/navbar';
import VerticalNavigation from '../navigation/vertical-navigation';
import PartnerInvoicesCard from './partner-invoices-card';

function PartnerInvoices() {
    return (
        <Navbar nav>
            <Row>
                <LeftSide addClass="">
                    <VerticalNavigation selected={'partner-invoices'} />
                </LeftSide>
                <Col xs={9} className="col-middle">
                    <Row>
                        <Col xs={8}>
                            <PartnerInvoicesCard />
                        </Col>
                    </Row>
                    <Row className={'spacer-tb'}>
                        <Col xs={8}></Col>
                    </Row>
                </Col>
            </Row>
        </Navbar>
    );
}

export default PartnerInvoices;
